import React from 'react'
import styled from 'styled-components'
import { mobileBreakpoint } from 'react-components'
import { shimmer, SkeletonBox } from '../card-skeletons/styles'
import { ListContainer } from './styles'

const SkeletonRow = styled.div`
    display: flex;
    gap: 1rem;
    overflow: hidden;
    padding: 0.1rem 0;

    @media (max-width: ${mobileBreakpoint.max}px) {
        gap: 0.75rem;
    }
`

const SkeletonCard = styled.div`
    flex: 0 0 calc(20% - 0.8rem);
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 0.75rem;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    animation: ${shimmer} 1.5s ease-in-out infinite;

    @media (max-width: ${mobileBreakpoint.max}px) {
        flex: 0 0 calc(66.67% - 0.5rem);
        padding: 1rem;
    }
`

interface Props {
    TitleContainer: React.ElementType
}

const RecentSearchesSkeleton: React.FC<Props> = ({ TitleContainer }) => (
    <>
        <TitleContainer>
            <SkeletonBox $width="12rem" $height="1.625rem" />
            <SkeletonBox $width="20rem" $height="1rem" margin="0.375rem 0 0" />
        </TitleContainer>
        <ListContainer>
            <SkeletonRow>
                {Array.from({ length: 5 }).map((_, i) => (
                    <SkeletonCard key={i}>
                        <SkeletonBox $width="65%" $height="1.125rem" />
                        <SkeletonBox $width="50%" $height="0.875rem" />
                        <SkeletonBox $width="35%" $height="0.875rem" margin="0.5rem 0 0" />
                    </SkeletonCard>
                ))}
            </SkeletonRow>
        </ListContainer>
    </>
)

export default RecentSearchesSkeleton
